import React from 'react';

import Permissions from '@/common/permissions';
import { Access } from '@/modules/core/components';
import FieldLevelAccessSetup from '@/modules/role/FieldLevelAccessSetup';

const FieldLevelAccessSetupPage = () => {

  return (
    <Access
      accessRequirements={[
        { permission: Permissions.VIEW_ROLES_AND_SECURITY },
      ]}>
      <FieldLevelAccessSetup isEditMode />
    </Access>
    
  );
};
export default FieldLevelAccessSetupPage;
